import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AuditRunStatusFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.AUDIT_RUN_STATUS}
        filterName={FilterName.AUDIT_RUN_STATUS}
        valueKey="auditRunStatuses"
        isNested={isNested}
      />
    )
  },
)
